import Pagination from '@mui/material/Pagination';
export default Pagination;
export * from '@mui/material/Pagination';
